import React from 'react';
import { Field } from 'redux-form';
import {
    renderNumberPercentage,
} from '../../../../Utils/renderField/renderField';
import { RenderNumber } from '../../../../Utils/renderField/renderReadField';
import { TablaDRC } from "./TablaDRC";
import { ModalDRC } from "./ModalDRC";
import './DatosDRC.css';

/**
 * Componente para renderizar los datos de DRC
 * Se creó para refactorizar el contenido en el componente general (LaboratorioForm)
 * Solo se hicieron cambios respectivos a la variación DRC
 * @param {*} props propiedades del componente
 * @param {function} props.clearDRCTemp funcion para limpiar el DRC temporal
 * @param {function} props.openModal funcion para abrir el modal
 * @param {number} props.drc_promedio promedio de DRC
 * @param {object} props.variacionDRC objeto con la variacion del DRC
 * @returns {JSX.Element} componente de datos de DRC
 */
export const renderDatosDRC = (props) => {
    const { clearDRCTemp, openModal, drc_promedio, variacionDRC } = props;

    // Puede servir para testing y verificar los cálculos
    const mostrarVariacionDRC = false;

    return (
        <div className="col-12 datos-drc-latex-edicion__container">
            <div className="datos-drc-latex-edicion__top">
                <button className="btn btn-secondary"
                    onClick={e => {
                        e.preventDefault();
                        clearDRCTemp();
                        openModal('drc')
                    }}>
                    AGREGAR DRC
                </button>
                <div className='datos-drc-latex-edicion__top-info-fields'>
                    <div className="d-flex align-items-center">
                        <span className="verde-secundario bold mr-2">DRC PROMEDIO</span>
                        <Field name="drc_promedio" component={renderNumberPercentage} disabled type="text" className="form-control"
                            input={{ value: drc_promedio }} />
                    </div>
                    {/* VARIACIÓN DRC */}
                    {mostrarVariacionDRC &&
                        <div className="d-flex align-items-center">
                            <span className="verde-secundario bold mr-2">VARIACIÓN DRC</span>
                            {variacionDRC.aplica ?
                                <RenderNumber value={variacionDRC.variacion} decimalScale={2} className="datos-drc-latex-edicion__dato-variacion"
                                    suffix=" %" />
                                :
                                <span className="datos-drc-latex-edicion__dato-variacion">No aplica</span>
                            }
                        </div>
                    }
                </div>
            </div>
            <ModalDRC { ...props } mostrarVariacionDRC={mostrarVariacionDRC} />
            <TablaDRC { ...props } mostrarVariacionDRC={mostrarVariacionDRC} />
        </div>
    )
};
